import { render, staticRenderFns } from "./TvaImageLazy.vue?vue&type=template&id=778c189b&scoped=true&"
import script from "./TvaImageLazy.vue?vue&type=script&lang=js&"
export * from "./TvaImageLazy.vue?vue&type=script&lang=js&"
import style0 from "./TvaImageLazy.vue?vue&type=style&index=0&id=778c189b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c189b",
  null
  
)

export default component.exports